export const QUICK_LOOK_MAX_HEIGHT = 224;
export const PADDING = '8px';
